import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { Ochno } from "./pages/Ochno";
import { Online } from "./pages/Online";
import { About } from "./pages/About";
import { Corporate } from "./pages/Corporate";
import "./App.css";

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/ochno" element={<Ochno />} />
              <Route path="/online" element={<Online />} />
              <Route path="/o-trenere" element={<About />} />
              <Route path="/korporativ" element={<Corporate />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
